import { render, staticRenderFns } from "./actionmodalnarrow.vue?vue&type=template&id=a8dea28c&scoped=true&"
import script from "./actionmodalnarrow.vue?vue&type=script&lang=js&"
export * from "./actionmodalnarrow.vue?vue&type=script&lang=js&"
import style0 from "./actionmodalnarrow.vue?vue&type=style&index=0&id=a8dea28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dea28c",
  null
  
)

export default component.exports